// types
import { ResourceTypeEnum } from '@/types/schema';

export const ALL_CONTENT_TYPES = [
  ResourceTypeEnum.Path,
  ResourceTypeEnum.Course,
  ResourceTypeEnum.Article,
  ResourceTypeEnum.MicroLearning,
  ResourceTypeEnum.Roleplay,
  ResourceTypeEnum.ExternalContent,
  ResourceTypeEnum.Scorm,
  ResourceTypeEnum.Quiz,
  ResourceTypeEnum.Task,
  ResourceTypeEnum.Survey,
  ResourceTypeEnum.Exercise,
];
